import { render, staticRenderFns } from "./DocumentEditNavigator.vue?vue&type=template&id=7d418e99&scoped=true&"
import script from "./DocumentEditNavigator.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditNavigator.vue?vue&type=style&index=0&id=7d418e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d418e99",
  null
  
)

export default component.exports